import { styled } from "styled-components";

export const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #383838;
  color: white;
  border: none;
  padding: 3px 12px;
  border-radius: 5px;
  cursor: pointer;
`;
